import React from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { PulseLoader } from "react-spinners";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  card: {
    width: "100%",
    maxWidth: 500,
    transition: "0.3s",
    boxShadow: "0px 14px 80px rgba(34, 35, 58, 0.2)",
    position: "relative",
    overflow: "initial",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    paddingLeft: 8,
    paddingRight: 8,
    [breakpoints.up("sm")]: {
      textAlign: "left",
      flexDirection: "row-reverse",
    },
  },
  media: {
    [breakpoints.up("sm")]: {
      marginRight: "initial",
      width: "30%",
      paddingTop: "30%",
      flexShrink: 0,
      marginLeft: "auto",
    },
  },
  overline: {
    color: "#ffffff",
    fontSize: "0.7rem",
    opacity: 0.7,
  },
  heading: {
    fontWeight: "400",
    color: "#ffffff",
    letterSpacing: 0.5,
  },
}));

export default function RewardCard({ value, image, background, title }) {
  const styles = useStyles();
  const [hover, setHover] = React.useState(false);

  return (
    <Card
      className={styles.card}
      style={{ opacity: hover ? 0.7 : 1, background }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <CardMedia
        className={styles.media}
        style={{ backgroundSize: "70%" }}
        image={image}
      />
      <CardContent className={styles.content} style={{ padding: 10 }}>
        <Typography variant={"overline"} style={{ color: "#fff" }}>
          {title}
        </Typography>
        <Typography className={styles.heading} variant={"h4"} gutterBottom>
          {value === "..." ? (
            <PulseLoader color="#fff" size={15} loading={true} />
          ) : (
            value
          )}
        </Typography>
      </CardContent>
    </Card>
  );
}
